/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

$(window).on('scroll', function () {
 setTimeout(function(){
    var cur_pos = $(this).scrollTop();
  
 $('.faq-content h3').each(function() {
    var top = $(this).offset().top - 55,
         bottom = top + $(this).outerHeight();
    
    if (cur_pos >= top && cur_pos <= bottom) {
      // console.log('current position is: ', cur_pos);
       $('.faq_aside').find('li').removeClass('is-selected');
     $('.faq-content h3').removeClass('is-selected');
        // $('.faq-content h3').next('.accordion').prop('open', 'true');
     
      
      $(this).addClass('is-selected');
      $('.widget__links--secondary').stop().animate({scrollLeft: "+=150"}, 200);
       $('.widget__links').find('button[data-href="#'+$(this).attr('id')+'"]').addClass('is-selected');
    }
   else if (cur_pos < top) {
     $('.widget__links--secondary').stop().animate({scrollLeft: "-=150"}, 200);
   }
   
  
  });
   // $('.faq-content h3.is-selected').next('.accordion').prop('open', 'true');
   //  $('.faq-content h3.is-selected').next('.accordion').find('[data-collapsible-trigger]').trigger('click');
 },100)
});



 
  


  // const video = document.querySelector('.video-background.sound');

  //   video.muted = false; // Ensure it's unmuted

  //   video.play().catch(error => {
  //     console.error("Autoplay with sound failed:", error);
  //   });
   

$(document).ready(function() {


  
 $('.widget__links').find('button').on('click', function () {
  var $el = $(this),
    id = $el.attr('data-href');
  
  $('html, body').animate({
    scrollTop: $(id).offset().top - 53,
  }, 50);

});
  });




  


})();
